<template>
  <div v-if="showAudioRecord" class="comp-container">
    <el-dropdown @command="onCommandChange">
      <div class="el-dropdown-link">
        <p class="ellipsis">{{ currentDevice.label }}</p>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) in deviceList"
          :key="index"
          :command="item.deviceId"
        >
          {{ item.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="center">
      <template v-if="status === 1">
        <div class="start-btn" @click="onClickRecord">
          <div class="icon-box">
            <i class="saas fa-yuyin2"></i>
          </div>
          <p>开始</p>
        </div>
      </template>
      <template v-else-if="status === 2">
        <div class="control-box">
          <audio-image></audio-image>
          <div class="control" @click="onClickEnd">
            <div class="pause-btn">
              <i class="saas fa-zanting"></i>
            </div>
            <div class="time">
              {{ getTime(recordDuration) }}/{{ getTime(maxDuration) }}
            </div>
          </div>
          <audio-image></audio-image>
        </div>
      </template>
      <template v-else-if="status === 3">
        <div class="control-box">
          <div class="restart-btn" @click="onClickRecord">
            <i class="saas fa-shuaxin"></i>
            重录
          </div>
          <div class="control" @click="onClickControl">
            <div v-if="!isPlaying" class="pause-btn">
              <i class="saas fa-icon_play"></i>
            </div>
            <div v-else class="pause-btn">
              <i class="saas fa-zanting"></i>
            </div>
            <div class="time">
              {{ getTime(progress) }}/{{ getTime(recordDuration) }}
            </div>
          </div>
          <div class="save-btn" @click="onClickSave">
            <i class="saas fa-dui"></i>
            保存
          </div>
        </div>
      </template>
    </div>
    <div class="close" @click="onClickClose">
      <i class="el-icon-close"></i>
    </div>
    <el-progress
      v-if="status === 3 && isShowProgress"
      class="play-progress"
      :percentage="getPercentage()"
      color="#00C89D"
      define-back-color="#E2FFF9"
      :show-text="false"
    ></el-progress>
    <!-- <el-button @click="onClickRecord">开始录音</el-button>
    <el-button @click="onClickEnd">结束录音</el-button>
    <el-button @click="onClickPause">暂停录音</el-button>
    <el-button @click="onClickResume">继续录音</el-button>
    <el-button @click="onClickPlay">播放录音</el-button>
    <el-button @click="onClickPausePlay">暂停播放</el-button>
    <el-button @click="onClickResumePlay">继续播放</el-button>
    <el-button @click="onClickStopPlay">停止播放</el-button>
    <div id="waveform"></div>
    <input type="file" accept=".xlsx,.xls" @change="onFileChange" /> -->
  </div>
</template>

<script>
import Recorder from "js-audio-recorder";
// import { cosUploadFile } from "@/utils/cos-upload";
import { cosUploadFile } from "@saas/components/src/utils/cos-upload";
// import { getSign } from "@/api/material";
import { getUploadSignature } from "@saas/service-api/src/material/index.js";
import AudioImage from "./AudioImage.vue";
import lamejs from "lamejs";

export default {
  components: {
    AudioImage,
  },

  data() {
    return {
      recorderInstance: null,
      deviceList: [],
      currentDevice: {},
      currentStream: null,
      status: 1, // 未开始录音 1，录音中 2， 结束3,
      recordDuration: 0, // 录音时长
      realRecordDuration: 0,
      progress: 0, // 播放进度 秒
      isPlaying: false,
      playTimer: null,
      startTime: 0,
      endTime: 0,
      loading: false,
      isShowProgress: false,
      showAudioRecord: null,
    };
  },
  computed: {
    // 录音最大时长， 单位秒
    maxDuration() {
      return 15 * 60;
    },
  },

  mounted() {
    this.recorderInstance = new Recorder({
      sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
      sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
      numChannels: 1, // 声道，支持 1 或 2， 默认是1
      // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
    });
    // 录音进度
    this.recorderInstance.onprogress = (params) => {
      console.log("录音进度》〉》〉》", params);

      // console.log(params) // 当前获取到到音频数据
      // console.log(params.duration.toFixed()) // 当前获取到到音频数据
      this.recordDuration = params.duration.toFixed();
      if (this.recordDuration >= this.maxDuration) {
        // 结束录音
        this.onClickEnd();
      }
      // console.log(this.recorderInstance.getRecordAnalyseData())
    };
    // 播放完成
    this.recorderInstance.onplayend = () => {
      this.isPlaying = false;
      this.endTime = performance.now();
      console.log("播放完成");
      console.log("播放时长", (this.endTime - this.startTime) / 1000);
      this.progress = this.recordDuration;
      clearInterval(this.playTimer);
    };
    // 播放停止
    // this.recorderInstance.onstopplay = () => {
    //   this.isPlaying = false
    //   clearInterval(this.playTimer)
    //   console.log(this.recorderInstance)
    //   console.log('播放停止')
    // }
    // this.recorderInstance.onpauseplay = () => {
    //   // console.log('onpauseplay')
    //   // // this.isPlaying = false
    //   // this.isPlaying = false
    //   // console.log(this.recorderInstance)
    //   // clearInterval(this.playTimer)
    //   // console.log('暂停播放')
    // }
    // this.recorderInstance.onresumeplay = () => {
    //   console.log('onresumeplay')
    //   console.log(this.recorderInstance)
    //   console.log('继续播放')
    // }
    // this.recorderInstance.onplay = () => {
    //   // 开始播放录音
    //   console.log('开始播放录音')
    // }
    this.requestMediaDevices();
  },
  beforeDestroy() {
    this.recorderInstance.stop();
    this.recorderInstance.destroy();
    clearInterval(this.playTimer);
  },
  methods: {
    async uploadAudio(file, callback) {
      getUploadSignature({
        fileName: file.name,
        materialType: 101,
      })
        .then((res) => {
          if (res.code === 1) {
            file.cos = cosUploadFile(
              {
                file: file,
                fileName: file.name,
                type: 101, //
              },
              {
                ...res.data,
              },
              {
                onError: () => {
                  this.loading = false;
                },
                onFileFinish: (err, data, options) => {
                  this.loading = false;
                  if (data && data.statusCode === 200) {
                    const location = data.Location;
                    const arr = location.split("/");
                    arr.shift();
                    const url = "https://cdn.moguocdn.com/" + arr.join("/");
                    this.$emit("update-audio-url", url);
                    this.$emit("close");
                    this.$message.success("保存成功");
                  } else {
                    console.log(err);
                  }
                },
              }
            );
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 请求访问
    async requestMediaDevices() {
      try {
        // 调用 getUserMedia 方法请求访问麦克风设备
        // 停止之前的音频流
        if (this.currentStream) {
          this.currentStream.getTracks().forEach((track) => track.stop());
        }
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        this.showAudioRecord = true;
        console.log("用户允许访问麦克风，已获取音频流:", stream);
        this.currentStream = stream;
        this.getMicrophones().then((res) => {
          this.deviceList = res;
          const currentDeviceId = this.currentStream
            .getAudioTracks()[0]
            .getSettings().deviceId;
          this.currentDevice = this.deviceList.find(
            (item) => item.deviceId === currentDeviceId
          );
          console.log("当前使用的麦克风设备：", this.currentDevice);
        });
        // 在这里可以对获取到的音频流进行进一步处理，例如播放或录制等
        // 为了简单演示，这里只是简单关闭音频流
        // stream.getTracks().forEach(track => track.stop())
      } catch (error) {
        this.showAudioRecord = false;
        if (error.name === "NotAllowedError") {
          console.log("用户拒绝访问麦克风");
          this.$showToast("请在浏览器设置中开启麦克风权限");
        } else {
          console.error("获取麦克风设备时发生其他错误:", error);
        }
      }
    },
    // 获取音频设备列表
    getMicrophones() {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .enumerateDevices()
          .then(function (devices) {
            resolve(devices.filter((d) => d.kind === "audioinput"));
          })
          .catch(function (err) {
            console.log(err.name + ": " + err.message);
          });
      });
    },
    // 获取摄像头
    getCameras() {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .enumerateDevices()
          .then(function (devices) {
            resolve(devices.filter((d) => d.kind === "videoinput"));
          })
          .catch(function (err) {
            console.log(err.name + ": " + err.message);
          });
      });
    },
    // 获取当前使用的麦克风
    getCurrentMicrophone() {
      // 停止之前的音频流
      if (this.currentStream) {
        this.currentStream.getTracks().forEach((track) => track.stop());
      }
      // 请求使用麦克风
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          console.log("stream>>>>", stream);
          this.currentStream = stream;
          console.log("currentStream>>>>", this.currentStream);
          // 音频轨道的设备ID对应的就是当前使用的麦克风设备
          const currentDeviceId = this.currentStream
            .getAudioTracks()[0]
            .getSettings().deviceId;
          this.currentDevice = this.deviceList.find(
            (item) => item.deviceId === currentDeviceId
          );
          console.log("当前使用的麦克风设备：", this.currentDevice);
        })
        .catch((error) => {
          console.error("获取麦克风设备失败：", error);
        });
    },
    getPercentage() {
      if (!this.recordDuration) {
        return 0;
      }
      if (+(this.progress / this.recordDuration) >= 1) {
        return 100;
      } else {
        return +((this.progress / this.recordDuration) * 100);
      }
    },
    async onCommandChange(val) {
      this.currentDevice = this.deviceList.find(
        (item) => item.deviceId === val
      );
      console.log("val>>>>", val);
      // const stream = await navigator.mediaDevices.getUserMedia({
      //   audio: { deviceId: { exact: val } }
      // })
      if (this.status === 2 || this.status === 3) {
        clearInterval(this.playTimer);
        this.recorderInstance.stop();
        setTimeout(() => {
          this.onClickRecord();
        }, 1000);
      }
    },
    onClickRecord() {
      this.isShowProgress = false;
      this.recorderInstance.stop();
      this.recorderInstance.stopPlay();
      Recorder.getPermission().then(
        () => {
          this.progress = 0;
          this.realRecordDuration = 0;
          this.recordDuration = 0;
          this.recorderInstance.start().then(() => {
            // this.startTime = performance.now()
            this.status = 2;
          });
        },
        (error) => {
          console.log(`${error.name} : ${error.message}`);
        }
      );
    },
    onClickSave() {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        // 暂停录音
        this.recorderInstance.stop();
        const wavBlob = this.recorderInstance.getWAVBlob(); // blob格式
        const file = new window.File([wavBlob], "name.wav", { type: "wav" }); // 转成file类型
        this.uploadAudio(file);
        // // 获取录音结果
        // const wavBlob = this.recorderInstance.getWAV()
        // const channelData = this.recorderInstance.getChannelData()
        // const mp3Bolb = this.wavToMp3(wavBlob, channelData)
        // this.loading = false
        // // 转成file类型
        // const file = new window.File([mp3Bolb], 'name.mp3', { type: 'audio/mp3' }) // 转成file类型
        // this.uploadAudio(file)
      } catch (error) {
        console.log("error>>>", error);
        this.loading = false;
      }
    },
    // 结束录音
    onClickEnd() {
      this.recorderInstance.stop();
      this.recordDuration = Math.floor(this.recorderInstance.duration);
      this.realRecordDuration = this.recorderInstance.duration;
      this.isPlaying = true;
      this.status = 3;
      this.isShowProgress = true;
      this.onClickPlay();
    },
    // 当点击控制区
    onClickControl() {
      if (this.isPlaying) {
        this.onClickPausePlay();
      } else {
        this.onClickPlay();
      }
    },
    // 点击暂停
    onClickPause() {
      this.recorderInstance.pause();
    },
    onClickResume() {
      this.recorderInstance.resume();
    },
    // 播放录音
    onClickPlay() {
      console.log("点击播放录音");

      if (this.progress === 0 || this.progress === this.recordDuration) {
        // 播放录音
        this.isShowProgress = false;
        this.progress = 0;
        setTimeout(() => {
          this.isShowProgress = true;
          clearInterval(this.playTimer);
          this.isPlaying = true;
          this.playTimer = setInterval(() => {
            const playTime = this.recorderInstance.getPlayTime();
            if (playTime <= this.recordDuration) {
              this.progress = playTime;
            }
          }, 10);
          // this.startTime = performance.now()
          this.recorderInstance.play();
        }, 1000);
      } else {
        // 继续播放
        this.isPlaying = true;
        this.recorderInstance.resumePlay();
        clearInterval(this.playTimer);
        this.playTimer = setInterval(() => {
          this.progress = this.recorderInstance.getPlayTime();
        }, 10);
      }
    },
    onPlayEnd() {
      clearInterval(this.playTimer);
      // this.progress = 0
    },
    onClickPausePlay() {
      //
      console.log("暂停播放");

      this.isPlaying = false;
      console.log(this.recorderInstance);
      clearInterval(this.playTimer);
      // this.isPlaying = false
      // this.progress = this.recorderInstance.getPlayTime()
      this.recorderInstance.pausePlay();
    },
    onClickResumePlay() {
      this.recorderInstance.resumePlay();
    },
    onClickStopPlay() {
      this.recorderInstance.stopPlay();
    },
    //  把秒转成十分
    getTime(time = 0) {
      // 向上取整
      time = Math.floor(time);
      const minute = Math.floor(time / 60);
      const second = time % 60;
      return `${minute < 10 ? "0" + minute : minute}:${
        second < 10 ? "0" + second : second
      }`;
    },
    // 获取录音文件
    // async getRecorder() {
    //   this.recordDuration = this.recorderInstance.duration.toFixed(); // 录音总时长
    //   // 录音结束，获取取录音数据
    //   let wavBlob = recorder.getWAVBlob(); // 获取 WAV 数据
    //   // 使用该插件只能导出wav格式的音频，然后把wav格式的音频转化为文件格式，方便使用接口的形式传给后端。
    //   var file = new File([wavBlob], "audio.wav", {
    //     type: "wav",
    //     lastModified: Date.now(),
    //   });
    // },
    onClickClose() {
      this.$emit("close");
    },
    wavToMp3(wavDataView, channelData) {
      // 获取wav头信息
      const wav = lamejs.WavHeader.readHeader(wavDataView); // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
      const { channels, sampleRate } = wav;
      const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128);
      // 获取左右通道数据
      const result = channelData;
      const buffer = [];
      const leftData =
        result.left &&
        new Int16Array(result.left.buffer, 0, result.left.byteLength / 2);
      const rightData =
        result.right &&
        new Int16Array(result.right.buffer, 0, result.right.byteLength / 2);
      const remaining = leftData.length + (rightData ? rightData.length : 0);
      const maxSamples = 1152;
      for (let i = 0; i < remaining; i += maxSamples) {
        const left = leftData.subarray(i, i + maxSamples);
        let right = null;
        let mp3buf = null;
        if (channels === 2) {
          right = rightData.subarray(i, i + maxSamples);
          mp3buf = mp3enc.encodeBuffer(left, right);
        } else {
          mp3buf = mp3enc.encodeBuffer(left);
        }
        if (mp3buf.length > 0) {
          buffer.push(mp3buf);
        }
      }
      const enc = mp3enc.flush();
      if (enc.length > 0) {
        buffer.push(enc);
      }
      return new Blob(buffer, { type: "audio/mp3" });
    },
  },
};
</script>

<style scoped lang="scss">
.comp-container {
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  background: #f7f8fa;
  border-radius: 0px 0px 12px 12px;
  border: 1px dashed #86909c;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 0 24px;
  position: relative;
  .el-dropdown-link {
    width: 150px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
  }
  // .el-dropdown ::v-deep {
  // }
  .center {
    .start-btn {
      width: 92px;
      height: 42px;
      background: #ffffff;
      border-radius: 21px;
      border: 1px solid #e5e6eb;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      .icon-box {
        width: 32px;
        height: 32px;
        background: linear-gradient(123deg, #00c89d 0%, #00eb81 100%);
        border-radius: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        margin-left: 5px;
        i {
          font-size: 22px;
        }
      }
      p {
        font-weight: 500;
        font-size: 16px;
        color: #00c89d;
        margin-left: 9px;
      }
      &:hover {
        background: linear-gradient(123deg, #00c89d 0%, #00eb81 100%);
        p {
          color: #fff;
        }
        .icon-box {
          background: transparent;
        }
      }
    }
    .control-box {
      display: flex;
      align-items: center;
      img {
        width: 110px;
      }
      .control {
        cursor: pointer;
        width: 146px;
        height: 42px;
        margin: 0 15px;
        background: #ffffff;
        border-radius: 21px;
        border: 1px solid #e5e6eb;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: var(--theme-color);
        display: flex;
        &:hover {
          background: #f1fffc;
          border-color: #f1fffc;
        }
        .pause-btn {
          cursor: pointer;
          font-size: 15px;
          color: #00c89d;
        }
        .time {
          margin-left: 10px;
          font-weight: 500;
          font-size: 16px;
          color: #4e5969;
        }
      }
    }
    .restart-btn,
    .save-btn {
      cursor: pointer;
      width: 64px;
      height: 26px;
      background: #f2f3f5;
      border-radius: 13px;
      font-weight: 500;
      font-size: 14px;
      color: #4e5969;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      i {
        margin-right: 5px;
      }
      &:hover {
        background: #f1fffc;
      }
    }
  }
  .close {
    cursor: pointer;
    color: var(--theme-color);
  }
  .play-progress ::v-deep {
    position: absolute;
    height: 5px;
    width: 100%;
    background: #bedaff;
    top: -1px;
    left: 0;
    z-index: 10;
    overflow: unset;
    .el-progress-bar__outer {
      border-radius: 0;
      overflow: unset;
    }
    .el-progress-bar__inner {
      border-radius: 0;
      // position: relative;
      overflow: unset;

      &::after {
        position: absolute;
        content: "";
        right: -7px;
        top: 50%;
        transform: translateY(-50%);
        width: 14px;
        height: 14px;
        border-radius: 7px;
        background: #ffffff;
        border: 2px solid #00c89d;
      }
    }
  }
}

// 适配
@media (max-width: 768px) {
  .comp-container {
    position: relative;
    min-height: 60px;
    height: auto;
    display: block;
    padding-bottom: 15px;
  }
  .center {
    display: flex;
    justify-content: center;
    margin-top: 6px;
  }
  .close {
    position: absolute;
    top: 0;
    right: 12px;
    i {
      font-size: 18px;
    }
  }
  .control-box {
    max-width: 100%;
    overflow: hidden;
    justify-content: center;
    .control {
      min-width: 146px;
    }
  }
}
</style>
